import { Routes } from './Route'
export const RoutesNavigationDefaults: Record<
  Routes,
  {
    hideNavigation?: boolean
  }
> = {
  [Routes.ACCOUNTS]: {},
  [Routes.CREATE_ACCOUNT]: {
    hideNavigation: true,
  },
  [Routes.PAYMENTS]: {},
  [Routes.PAYOUTS]: {},
  [Routes.INVOICES]: {},
  [Routes.INVOICES_REFUND]: {
    hideNavigation: true,
  },
  [Routes.REFUND_REQUESTS]: {},
  [Routes.OVERVIEW]: {},
  [Routes.PAYMENTS_REFUND]: {
    hideNavigation: true,
  },
}
